import React, {useEffect, useState, useMemo} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import { Button,Typography, RadioGroup, Radio, FormControlLabel, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, IconButton } from '@material-ui/core';
import EditIcon from '@material-ui/icons/Edit';
import WizardQuestionView from './WizardQuestionView';
import { makeRTL, isRTL } from './utils';
import { isMobile } from 'react-device-detect';
import * as Actions from "../redux/actions";

const useStyles = makeStyles({
    mainContainer:{
        margin: 'auto',
        width: isMobile ? '320px' : '600px',
        backgroundColor: 'white',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'stretch', 
        alignContent: 'stretch'
    },
    title: {
        fontFamily: 'Assistant',
        fontSize: '26px',
        fontWeight: '700',
        letterSpacing: '0px',
        color: '#35373D',
        // margin: '35px 32px'
        marginLeft: '32px',
        marginRight: '32px',
        // marginTop: '24px',
    },
    text: {
        fontFamily: 'Assistant',
        fontSize: '18px',
        fontWeight: '700',
        margin: '-4px 32px 0px 32px',
        color: '#777777'
    },
    explanation: {
        fontFamily: 'Assistant',
        fontSize: '14px',
        color: '#777777',
        margin: '0px 32px',
        fontStyle: 'italic'
    },
    label: {
        opacity: '0.77',
        fontFamily: 'Assistant',
        fontSize: '11px',
        fontWeight: 'normal',
        fontStyle: 'normal',
        fontStretch: 'normal',
        lineHeight: 'normal',
        letterSpacing: '0.22px',
        textAlign: 'center',
        color: '#97a1b0',        
    },
    indicator: {
        backgroundColor: "#1274e4"
    },
    tab: {
        backgroundColor: 'white',
        boxShadow: 'none',
        '&.MuiTab-root': {
            width: '50%'
        },
        '&.Mui-selected > span > span': {
            fontFamily: 'Assistant',
            fontSize: '11px',
            fontWeight: '700',
            fontStyle: 'normal',
            fontStretch: 'normal',
            lineHeight: 'normal',
            letterSpacing: '0.12px',
            textAlign: 'center',
            color: '#162250'            
        }        
    },
    formGroup: {
        flexDirection: 'row'
    },
    radioGroup: {
        marginLeft: '24px',
        marginRight: '24px',
    },
    layout: {
        display: 'flex',
        flexDirection: 'row'
    },
    repeatLeftSide: {
        overflowY: 'hidden',
        overflowX: 'hidden !important',
        display: 'flex',
        flexDirection: 'column',
        marginRight: '12px',
        marginLeft: '12px',
        width: '25%'
    },
    contentRightSide: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'stretch', 
        alignContent: 'stretch',
        flexGrow: 1,
        overflowY: 'hidden'
    },
    selected: {
        backgroundColor: '#1274e4 !important',
        color: 'white !important'
    },
    previewTableContainer: {
        margin: '0px 32px 10px 32px',
        paddingTop: '0px',
        width: 'calc(100% - 64px)',
        overflowX: 'auto',
        overflowY: 'visible',
        scrollbarWidth: 'thin',
        scrollbarColor: 'rgb(170, 215, 250) transparent',
        '&::-webkit-scrollbar': {
            WebkitAppearance: 'none',
            height: '12px',
            border: '1px solid rgb(170, 215, 250)',
            backgroundColor: 'rgb(170, 215, 250)'
        },
        '&::-webkit-scrollbar-thumb': {
            borderRadius: 0,
            backgroundColor: 'rgb(170, 215, 250)',
            boxShadow: '0 0 1px rgba(255, 255, 255, .5)'
        },
        '&::-webkit-scrollbar-track': {
            backgroundColor: 'white',
            border: 'none'
        }
    },
    previewTable: {
        minWidth: '100%',
        borderCollapse: 'collapse'
    },
    previewTablePaper: {
        boxShadow: 'none'
    },
    previewTableHeader: {
        backgroundColor: '#f5f5f5',
        fontWeight: '700',
        fontFamily: 'Assistant',
        fontSize: '14px',
        color: '#35373D',
        padding: '8px 12px',
        border: '1px solid #e0e0e0',
        textAlign: 'left',
        '&.MuiTableCell-root': {
            textAlign: 'left'
        }
    },
    previewTableHeaderRTL: {
        '&.MuiTableCell-root': {
            textAlign: 'right !important'
        },
        '&.MuiTableCell-head': {
            textAlign: 'right !important'
        },
        '&.MuiTableCell-alignLeft': {
            textAlign: 'right !important'
        },
        '&.MuiTableCell-alignRight': {
            textAlign: 'right !important'
        },
        textAlign: 'right !important'
    },
    asterisk: {
        color: '#d32f2f',
        marginLeft: '2px'
    },
    previewTableCell: {
        fontFamily: 'Assistant',
        fontSize: '14px',
        color: '#35373D',
        padding: '8px 12px',
        border: '1px solid #e0e0e0',
        whiteSpace: 'nowrap',
        textAlign: 'left'
    },
    previewTableCellEmpty: {
        fontFamily: 'Assistant',
        fontSize: '14px',
        color: '#d32f2f',
        padding: '8px 12px',
        border: '1px solid #d32f2f',
        whiteSpace: 'nowrap',
        backgroundColor: '#ffebee',
        fontWeight: '600',
        textAlign: 'left'
    },
    editIconButton: {
        padding: '4px',
        '&:hover': {
            backgroundColor: 'rgba(0, 0, 0, 0.04)'
        }
    },
    editIcon: {
        fontSize: '18px',
        color: '#1274e4'
    },
    disabledButton: {
        opacity: 0.5,
        cursor: 'not-allowed',
        '&:hover': {
            backgroundColor: '#1274E40C !important'
        }
    },
    previewTableLinkContainer: {
        marginTop: '10px',
        display: 'flex',
        alignItems: 'center'
    },
    previewTableExpandButton: {
        position: 'relative',
        marginTop: '10px',
        left: '0px',
        height: 'auto',
        background: 'transparent',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        cursor: 'pointer',
        zIndex: 10,
        pointerEvents: 'none'
    },
    expandTextLink: {
        fontFamily: 'Assistant',
        fontSize: '14px',
        fontWeight: '600',
        color: '#1274e4',
        cursor: 'pointer',
        textDecoration: 'none',
        display: 'inline-block',
        '&:hover': {
            textDecoration: 'underline'
        }
    }
});

const RepeatStyledButton = withStyles(theme => ({
    root: {
        width: '128px',
        minHeight: '42px',
        height: 'auto',
        fontFamily: 'Assistant',
        fontSize: '12px',
        fontWeight: '600',
        fontStyle: 'normal',
        fontStretch: 'normal',
        lineHeight: '1.2',
        letterSpacing: 'normal',
        textAlign: 'center',
        borderRadius: '21px',
        color: 'black',
        backgroundColor: '#1274E40C',
        margin: '12px',
        padding: '8px 12px',
        whiteSpace: 'normal',
        wordWrap: 'break-word',
        overflowWrap: 'break-word',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        '&:hover': {
            backgroundColor: '#1060BB'
      },
      '&:disabled': {
          opacity: 0.5,
          cursor: 'not-allowed',
          backgroundColor: '#1274E40C'
      }
    },
}))(Button);

export default function WizardMultipleQuestionView({question, onAnswerChange, contactsValue}) {
    const classes = useStyles();
    const repeatType = question.repeat_type;
    const SEPARATOR = '|';
    const isRepeating = repeatType && repeatType !== '' && repeatType !== 'do_no_repeat';
    const children =  question.children;
    const questionnaire = useSelector(state => state.questionnaire);
    const partyQuestion = question.children && question.children.filter(q => q.read_only)[0];

    const originalAnswer = questionnaire[question.id];
    const rootAnswer = originalAnswer !== undefined ? originalAnswer : isRepeating ?
        [{ question_id: question.id, children:[] }]:
        { question_id: question.id, children: [] };
    const [repeatSelectedIndex, setRepeatSelectedIndex] = useState(0);
    const [isTableVisible, setIsTableVisible] = useState(false);

    const childAnswers = {};
    if (rootAnswer.children) { //this is multi and not repeating
        for (let i = 0; i < rootAnswer.children.length; ++i) {
            childAnswers[rootAnswer.children[i].question_id] = rootAnswer.children[i];
        }
    } else if (isRepeating) {// this is repeating
        // TODO i add this condition becouse it producese error. I dont know will it affect document generation, so we need to resourched
        if( rootAnswer[repeatSelectedIndex] &&  rootAnswer[repeatSelectedIndex].children){
            const _rootAnswerChildren = rootAnswer[repeatSelectedIndex].children;
            for (let i = 0; i < _rootAnswerChildren.length; ++i) {
                childAnswers[_rootAnswerChildren[i].question_id] = _rootAnswerChildren[i];
            }
        }
    }
    const partyValue = partyQuestion && childAnswers[partyQuestion.id] ? childAnswers[partyQuestion.id].value : undefined;
    const RTL = isRTL(question.title);
    const linkInText = RTL ? 'לחצו כאן' : 'click here';
    const dispatch = useDispatch();

    const text = question.text;
    const explanationText = question.explanation_text;
    let newText = '';
    let newTextForExplanation = '';

    if (text && text.includes('http') ) {
        let textArr = text.split(' ');
        for (let i = 0; i < textArr.length; ++i) {
            if(textArr[i].includes('http')){
                const link = ` <a target='_blank' href = '${textArr[i]}'>${linkInText}</a> `;
                newText += `${link} `;
            } else {
                newText += `${textArr[i]} `;
            }
        }
    } else {
        newText = question.text;
    }

    if (explanationText && explanationText.includes('http') ) {
        let textArr = explanationText.split(' ');
        for (let i = 0; i < textArr.length; ++i) {
            if(textArr[i].includes('http')){
                const link = ` <a target='_blank' href = '${textArr[i]}'>${linkInText}</a> `;
                newTextForExplanation += `${link} `;
            } else {
                newTextForExplanation += `${textArr[i]} `;
            }
        }
    } else {
        newTextForExplanation = explanationText;
    }

    const partFormAddContactData = () => {
        const getContactValueFromArray = (index, contactValue)=>{
            const arrContactValue = contactValue?.split(SEPARATOR);
            if(arrContactValue){
                return arrContactValue[index] || contactValue;
            } else {
                return contactValue;
            }
        }

        const {children: questionChildrenForPartyForm} = question;

            let arrQuestionChildrenForPartyForm=[];
            let childrenArr=[];

            if(rootAnswer.children) {
                childrenArr = [...rootAnswer.children];
            } else {
                childrenArr = [...rootAnswer];
            }

            const lengthFromContactArr = []
            for (let i = 0; i < questionChildrenForPartyForm.length; ++i) {
                let usedContactField = questionChildrenForPartyForm[i].contact_field;
                if (usedContactField !== undefined ) {
                    lengthFromContactArr.push(
                        contactsValue[questionChildrenForPartyForm[i].contact_field]?.split(SEPARATOR).filter(segment => segment.trim()).length
                    );
                }
            }

            let minLengthFromContactArr = 0;
            if(lengthFromContactArr.length){
                minLengthFromContactArr = lengthFromContactArr.reduce((a, b) => Math.min(a, b))
            }


            if(childrenArr.length < minLengthFromContactArr){
                for (let i = childrenArr.length; i < minLengthFromContactArr; ++i) {
                    childrenArr.push(childrenArr[0])
                }
            }

            const newChildrenArr = [];

            for (let i = 0; i < childrenArr.length; ++i) {

                const {children} = childrenArr[i];

                const newChildrenArrInner = [];

                if(children && children.length){
                    for (let j = 0; j < children.length; ++j) {

                        const getValue = getContactValueFromArray(i, children[j].value || contactsValue[questionChildrenForPartyForm[j].contact_field] )

                        if (getValue) {
                            newChildrenArrInner.push({...children[j], value:getValue})
                        } else {
                            newChildrenArrInner.push({...children[j], value:''})
                        }
                    }
                    newChildrenArr.push({...childrenArr[i], children: newChildrenArrInner})
                } else {
                    if (i===0){
                        newChildrenArr.push(childrenArr[i] )
                    } else {
                            newChildrenArr.push(childrenArr[i] )
                    }



                }



            }

            if(newChildrenArr.length){
                childrenArr = newChildrenArr;
            }

            for (let i = 0; i < questionChildrenForPartyForm.length; ++i) {

                let usedContactField = questionChildrenForPartyForm[i].contact_field;

                if (usedContactField !== undefined) {
                    if (i === 0 && partyQuestion !== undefined) {
                        let answer = {
                            question_id: questionChildrenForPartyForm[i].id,
                            value: partyValue || ''
                        }
                        arrQuestionChildrenForPartyForm.push(answer);
                    } else if (questionChildrenForPartyForm[i]?.conditions[0]?.value === partyValue) {

                        let answerWithoutContactData = childrenArr.find(f => f.question_id === questionChildrenForPartyForm[i].id)?.value;
                        let otherValueData = childrenArr.find(f => f.question_id === questionChildrenForPartyForm[i].id)?.other_value;

                        if (answerWithoutContactData === undefined && childrenArr.children === undefined) {
                            if (childrenArr[repeatSelectedIndex]?.children  !== undefined ){
                                const existingChild = childrenArr[repeatSelectedIndex].children.find(f => f.question_id === questionChildrenForPartyForm[i].id);
                                answerWithoutContactData = existingChild?.value || '';
                                otherValueData = existingChild?.other_value;
                            } else {
                                const existingChild = childrenArr.find(f => f.question_id === questionChildrenForPartyForm[i].id);
                                answerWithoutContactData = existingChild?.value || '';
                                otherValueData = existingChild?.other_value;
                            }
                        }
                        let answer = {
                            question_id: questionChildrenForPartyForm[i].id,
                            value: answerWithoutContactData || contactsValue[questionChildrenForPartyForm[i].contact_field],
                        }
                        if (otherValueData) {
                            answer.other_value = otherValueData;
                        }

                        console.log('------answer123----', answer)

                        arrQuestionChildrenForPartyForm.push(answer);
                    }
                } else {
                    let answer = {}
                    if( childrenArr[repeatSelectedIndex]?.children !== undefined ) {
                        const existingChild = childrenArr[repeatSelectedIndex].children.find(f => f.question_id === questionChildrenForPartyForm[i].id);
                        answer = {
                            question_id: questionChildrenForPartyForm[i].id,
                            value: existingChild?.value || ''
                        }
                        if (existingChild?.other_value) {
                            answer.other_value = existingChild.other_value;
                        }
                    } else {
                        const existingChild = childrenArr.find(f => f.question_id === questionChildrenForPartyForm[i].id);
                        answer = {
                            question_id: questionChildrenForPartyForm[i].id,
                            value: existingChild?.value || ''
                        }
                        if (existingChild?.other_value) {
                            answer.other_value = existingChild.other_value;
                        }
                    }
                    console.log('------answer1234----', answer)
                    arrQuestionChildrenForPartyForm.push(answer);
                }

            }
            if(rootAnswer.children) {
                childrenArr = {question_id: rootAnswer.question_id, children: arrQuestionChildrenForPartyForm}
            } else {
                childrenArr[repeatSelectedIndex] = {question_id: rootAnswer[repeatSelectedIndex].question_id, children: arrQuestionChildrenForPartyForm}
            }

            //console.log('childrenArr', childrenArr)
            dispatch(Actions.saveAnswer(childrenArr));

    }

    useEffect((child={}) => {
        if(contactsValue || partyValue) {
            if (Object.keys(contactsValue).length && partyQuestion === undefined && rootAnswer?.children && question?.children) {
                const cc = [...rootAnswer.children];
                for (let i = 0; i < question.children.length; ++i) {

                    let contactFieldName = question.children[i].contact_field;
                    if (contactsValue[contactFieldName]){
                        const existingOtherValue = cc[i]?.other_value;
                        cc[i] = {
                            ...cc[i], value : contactsValue[contactFieldName] || '', question_id:question.children[i].id
                        }
                        if (existingOtherValue && cc[i].value === 'OTHER_VALUE_ENCODING') {
                            cc[i].other_value = existingOtherValue;
                        }
                    }
                }
                const toUse = {question_id: question.id, ...rootAnswer, children: rootAnswer?.children || cc };

                dispatch(Actions.saveAnswer(toUse));
            } else if (Object.keys(contactsValue).length && partyQuestion === undefined && !rootAnswer.children){
                partFormAddContactData();
            }

            if (Object.keys(contactsValue).length && partyQuestion !== undefined && partyValue ){
                partFormAddContactData();
            }
            if (contactsValue && Object.keys(contactsValue).length > 0) {
                partFormAddContactData();
            }
        }

    }, [contactsValue, partyValue, question]);

    const checkEntityValidity = (entityIndex) => {
        if (!isRepeating || !Array.isArray(rootAnswer) || !rootAnswer[entityIndex]) {
            return true;
        }
        const entityAnswers = rootAnswer[entityIndex].children || [];
        const entityPartyValue = partyQuestion && entityAnswers.find(a => a.question_id === partyQuestion.id)?.value;
        for (let i = 0; i < children.length; ++i) {
            const childQ = children[i];
            if (childQ.read_only) continue;
            if (partyQuestion && childQ.conditions && childQ.conditions.length > 0) {
                const condition = childQ.conditions[0];
                if (condition.question_id === partyQuestion.id && condition.value !== entityPartyValue?.toString()) {
                    continue;
                }
            }
            if (childQ.mandatory) {
                const answer = entityAnswers.find(a => a.question_id === childQ.id);
                const value = answer?.value || '';
                const otherValue = answer?.other_value || '';
                if (!value.trim() && !otherValue.trim()) {
                    return false;
                }
            }
        }
        return true;
    };

    const areAllEntitiesValid = () => {
        if (!isRepeating || !Array.isArray(rootAnswer)) {
            return true;
        }
        for (let i = 0; i < rootAnswer.length; ++i) {
            if (!checkEntityValidity(i)) {
                return false;
            }
        }
        return true;
    };

    const formatAnswerValue = (answer, questionType) => {
        if (!answer) return '';
        const value = answer.value || '';
        const otherValue = answer.other_value || '';
        if (value === 'OTHER_VALUE_ENCODING' && otherValue) {
            return otherValue;
        }
        if (questionType === 'checkboxes' && value.includes('•')) {
            return value.split('•').filter(v => v.trim()).join(', ');
        }
        return value;
    };

    const onChildAnswerChange = async (child) => {
        const answer =  isRepeating ? rootAnswer[repeatSelectedIndex] : //if repeating we copy the array as is and change the changed index 
            questionnaire[question.id];
        console.log('when starting:', questionnaire[question.id]);

        let found = -1;
        for (let i = 0; i < answer.children.length; ++i) {
            if (child.question_id.toString() === answer.children[i].question_id.toString()) {
                found = i;
                break;
            }
        }
        let cc = [...answer.children];            
        if (found < 0) {
            cc.push(child);
        } else {
            cc[found] = child;
        }
        
        if (isRepeating) {
            const toUse = [...rootAnswer];
            toUse[repeatSelectedIndex] = {question_id: question.id, children: cc};
            onAnswerChange(toUse);
        } else { 
            console.log({answer});
            // const toUse = Object.assign( {}, answer, {children: cc});
            // console.log('TOUSE', {toUse, answer}, questionnaire[question.id]);
            const toUse = {question_id: question.id, ...answer, children: cc};
            console.log('FFINSIHIN:', toUse, answer, questionnaire[question.id]);
            onAnswerChange(toUse);
        }
    };

    const getVisibleQuestions = (entityPartyValue) => {
        if (!partyQuestion) {
            return children.filter(q => !q.read_only);
        }
        return children.filter(q => {
            if (q.read_only) return false;
            if (!q.conditions || q.conditions.length === 0) return false;
            const condition = q.conditions[0];
            return condition.question_id === partyQuestion.id && condition.value === entityPartyValue?.toString();
        });
    };

    const isEntityComplete = (entity, entityIndex) => {
        if (!entity.children || entity.children.length === 0) {
            return false;
        }
        const entityPartyValue = partyQuestion && entity.children?.find(a => a.question_id === partyQuestion.id)?.value;
        const entityVisibleQuestions = getVisibleQuestions(entityPartyValue);
        
        for (let i = 0; i < entityVisibleQuestions.length; ++i) {
            const childQ = entityVisibleQuestions[i];
            if (childQ.mandatory) {
                const answer = entity.children?.find(a => a.question_id === childQ.id);
                const value = answer?.value || '';
                const otherValue = answer?.other_value || '';
                if (!value.trim() && !otherValue.trim()) {
                    return false;
                }
            }
        }
        return true;
    };

    const isFieldEmpty = (entity, questionId) => {
        const answer = entity.children?.find(a => a.question_id === questionId);
        const value = answer?.value || '';
        const otherValue = answer?.other_value || '';
        return !value.trim() && !otherValue.trim();
    };

    const hasEntityAnyData = (entity) => {
        if (!entity.children || entity.children.length === 0) {
            return false;
        }
        for (let i = 0; i < entity.children.length; ++i) {
            const answer = entity.children[i];
            const value = answer?.value || '';
            const otherValue = answer?.other_value || '';
            if (value.trim() || otherValue.trim()) {
                return true;
            }
        }
        return false;
    };

    const renderPreviewTable = () => {
        if (!isRepeating || !Array.isArray(rootAnswer) || rootAnswer.length <= 1) {
            return null;
        }
        if (!isTableVisible) {
            return (
                <div className={classes.previewTableContainer}>
                    <div className={classes.previewTableLinkContainer} style={{ justifyContent: RTL ? 'flex-end' : 'flex-start', width: '100%' }}>
                        <span 
                            className={classes.expandTextLink}
                            onClick={() => setIsTableVisible(true)}
                            style={{ display: 'block', textAlign: RTL ? 'right' : 'left' }}
                        >
                            {RTL ? 'הצג טבלת תצוגה מקדימה' : 'Show preview table'}
                        </span>
                    </div>
                </div>
            );
        }
        const lastEntityIndex = rootAnswer.length - 1;
        const lastEntity = rootAnswer[lastEntityIndex];
        const isLastEntityComplete = isEntityComplete(lastEntity, lastEntityIndex);
        
        const entitiesToShow = isLastEntityComplete 
            ? rootAnswer 
            : rootAnswer.slice(0, -1);
        
        const completedEntities = entitiesToShow
            .map((entity, index) => ({ entity, originalIndex: index }))
            .filter(({ entity }) => hasEntityAnyData(entity));
        
        if (completedEntities.length === 0) {
            return null;
        }
        const firstEntityPartyValue = partyQuestion && completedEntities[0]?.entity?.children?.find(a => a.question_id === partyQuestion.id)?.value;
        const visibleQuestions = getVisibleQuestions(firstEntityPartyValue);
        if (visibleQuestions.length === 0) {
            return null;
        }
        const tableDirection = RTL ? 'rtl' : 'ltr';
        
        return (
            <div className={classes.previewTableContainer}>
                <TableContainer 
                    component={Paper} 
                    className={classes.previewTablePaper} 
                    style={{ width: '100%', overflowX: 'auto', direction: tableDirection }}
                >
                    <Table className={classes.previewTable} style={{ minWidth: 'max-content', width: '100%', direction: tableDirection }}>
                        <TableHead>
                            <TableRow>
                                {visibleQuestions.map((q) => (
                                    <TableCell 
                                        key={q.id} 
                                        className={`${classes.previewTableHeader} ${RTL ? classes.previewTableHeaderRTL : ''}`}
                                        align={RTL ? 'right' : 'left'}
                                        style={{ 
                                            direction: RTL ? 'rtl' : 'ltr',
                                            textAlign: RTL ? 'right' : 'left'
                                        }}
                                    >
                                        <div style={{ textAlign: RTL ? 'right' : 'left', width: '100%' }}>
                                            {q.title || q.text || ''}
                                            {q.mandatory && <span className={classes.asterisk}>*</span>}
                                        </div>
                                    </TableCell>
                                ))}
                                <TableCell 
                                    className={`${classes.previewTableHeader} ${RTL ? classes.previewTableHeaderRTL : ''}`}
                                    align={RTL ? 'right' : 'left'}
                                    style={{ 
                                        width: '60px', 
                                        direction: RTL ? 'rtl' : 'ltr',
                                        textAlign: RTL ? 'right' : 'left'
                                    }}
                                >
                                    <div style={{ textAlign: RTL ? 'right' : 'left', width: '100%' }}>
                                        {RTL ? 'עריכה' : 'Edit'}
                                    </div>
                                </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {completedEntities.map(({ entity, originalIndex }) => {
                                const entityPartyValue = partyQuestion && entity.children?.find(a => a.question_id === partyQuestion.id)?.value;
                                const entityVisibleQuestions = getVisibleQuestions(entityPartyValue);
                                return (
                                    <TableRow key={originalIndex}>
                                        {entityVisibleQuestions.map((q) => {
                                            const answer = entity.children?.find(a => a.question_id === q.id);
                                            const displayValue = formatAnswerValue(answer, q.type);
                                            const isEmpty = isFieldEmpty(entity, q.id);
                                            const isMandatoryEmpty = q.mandatory && isEmpty;
                                            return (
                                                <TableCell 
                                                    key={q.id} 
                                                    className={isMandatoryEmpty ? classes.previewTableCellEmpty : classes.previewTableCell}
                                                    style={{ textAlign: RTL ? 'right' : 'left', direction: RTL ? 'rtl' : 'ltr' }}
                                                >
                                                    <div style={{ textAlign: RTL ? 'right' : 'left' }}>
                                                        {displayValue || (isMandatoryEmpty ? 'Required' : '-')}
                                                    </div>
                                                </TableCell>
                                            );
                                        })}
                                        <TableCell 
                                            className={classes.previewTableCell}
                                            style={{ textAlign: RTL ? 'right' : 'left', direction: RTL ? 'rtl' : 'ltr' }}
                                        >
                                            <div style={{ textAlign: RTL ? 'right' : 'left', display: 'inline-block' }}>
                                                <IconButton
                                                    className={classes.editIconButton}
                                                    onClick={() => {
                                                        setRepeatSelectedIndex(originalIndex);
                                                    }}
                                                    title={RTL ? 'עריכה' : 'Edit'}
                                                    size="small"
                                                >
                                                    <EditIcon className={classes.editIcon} />
                                                </IconButton>
                                            </div>
                                        </TableCell>
                                    </TableRow>
                                );
                            })}
                        </TableBody>
                    </Table>
                </TableContainer>
                <div className={classes.previewTableLinkContainer} style={{ justifyContent: RTL ? 'flex-end' : 'flex-start', width: '100%' }}>
                    <span 
                        className={classes.expandTextLink}
                        onClick={() => setIsTableVisible(false)}
                        style={{ display: 'block', textAlign: RTL ? 'right' : 'left' }}
                    >
                        {RTL ? 'הסתר טבלת תצוגה מקדימה' : 'Hide preview table'}
                    </span>
                </div>
            </div>
        );
    };

    let header = <div>
        <Typography className={classes.title}>{question.title}</Typography>
        {newText && <Typography className={classes.text}> <p dangerouslySetInnerHTML={{ __html:newText }}></p></Typography>}
        {newTextForExplanation && <Typography className={classes.explanation}> <p dangerouslySetInnerHTML={{ __html:newTextForExplanation }}></p></Typography>}
    </div>;

    const addAnother = async () => {
        let toUse = [...rootAnswer];
        toUse.push({question_id: question.id, children: rootAnswer[0].children.map(c => {
                if(Object.keys(contactsValue).length){
                    let findContactData = question.children.find(contactField => contactField.id === c.question_id)?.contact_field;
                    if (findContactData !== undefined && contactsValue[findContactData] !== undefined) {
                        return Object.assign({}, c, {
                            value: contactsValue[findContactData].includes('|') ? '' : contactsValue[findContactData] || '',
                            other_value: ''
                        });
                    } else {
                        return Object.assign({}, c, {value: '', other_value: ''});
                    }
                } else {
                    return Object.assign({}, c, {value: '', other_value: ''});
                }
        })});
        onAnswerChange(toUse);
        await setRepeatSelectedIndex(rootAnswer.length);
    };

    const removeAnother = async (indexToRemove) => {
        if (rootAnswer.length <= 1) return; // Don't allow removing the last item
        if (indexToRemove < 0 || indexToRemove >= rootAnswer.length) return;
        
        let toUse = [...rootAnswer];
        toUse.splice(indexToRemove, 1);
        
        let newSelectedIndex = repeatSelectedIndex;
        if (indexToRemove === repeatSelectedIndex) {
            newSelectedIndex = Math.max(0, indexToRemove - 1);
        } else if (indexToRemove < repeatSelectedIndex) {
            newSelectedIndex = repeatSelectedIndex - 1;
        }
        
        newSelectedIndex = Math.min(newSelectedIndex, toUse.length - 1);
        
        onAnswerChange(toUse);
        await setRepeatSelectedIndex(newSelectedIndex);
    };

    let radioGroup =(<RadioGroup value={partyValue} style={{flexDirection: 'row', marginLeft: '24px', marginRight: '24px'}} onChange={e=>{
        onChildAnswerChange({ question_id: partyQuestion.id, value: e.target.value });
    }} className={classes.radio}>
        <FormControlLabel key={0} value="0" control={<Radio />} label={RTL ? 'פרטי' : 'INDIVIDUAL'} />
        <FormControlLabel key={1} value="1" control={<Radio />} label={RTL ? 'חברה' : 'CORPORATION'} />
    </RadioGroup>);
    const addAnotherLabel = RTL ? 'הוספה' :'Add Another'

    let repeatButtons = [];
    if (isRepeating) {
        for (let i = 0; i < rootAnswer.length; i++) {
            const isSelected = i === repeatSelectedIndex;
            const canDelete = rootAnswer.length > 1;
            
            repeatButtons.push(
                <div key={`container-${i}`} style={{ 
                    display: 'flex', 
                    alignItems: 'center', 
                    marginBottom: '8px',
                    paddingLeft: RTL ? '0' : '20px',
                    paddingRight: RTL ? '20px' : '0',
                    position: 'relative'
                }}>
                    {canDelete && (
                        <button
                            onClick={async (e) => {
                                e.stopPropagation();
                                await removeAnother(i);
                            }}
                            style={{
                                position: 'absolute',
                                left: RTL ? 'auto' : '0',
                                right: RTL ? '0' : 'auto',
                                top: '50%',
                                transform: 'translateY(-50%)',
                                width: '16px',
                                height: '16px',
                                border: '1px solid #cccccc',
                                borderRadius: '0',
                                backgroundColor: 'transparent',
                                color: '#999999',
                                cursor: 'pointer',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                fontSize: '10px',
                                fontWeight: 'normal',
                                transition: 'all 0.2s ease',
                                zIndex: 1
                            }}
                            title={RTL ? "מחק פריט זה" : "Delete this item"}
                            onMouseEnter={(e) => {
                                e.target.style.backgroundColor = '#f0f0f0';
                                e.target.style.borderColor = '#999999';
                                e.target.style.color = '#666666';
                            }}
                            onMouseLeave={(e) => {
                                e.target.style.backgroundColor = 'transparent';
                                e.target.style.borderColor = '#cccccc';
                                e.target.style.color = '#999999';
                            }}
                        >
                            ×
                        </button>
                    )}
                    <RepeatStyledButton 
                        className={isSelected ? classes.selected : ''}
                        onClick={async ()=>{await setRepeatSelectedIndex(i)}}
                        style={{ width: '100%' }}
                    >
                        {`${question.title} ${i + 1}`}
                    </RepeatStyledButton>
                </div>
            );
        }
        if (repeatButtons.length === 0) 
            repeatButtons.push(<RepeatStyledButton key={'0'} onClick={async ()=>{await setRepeatSelectedIndex(0)}}>{`${question.title} 1`}</RepeatStyledButton>);
        if (repeatType === 'let_user_add') {
            const allValid = areAllEntitiesValid();
            repeatButtons.push(
                <RepeatStyledButton 
                    key={rootAnswer.length + 1} 
                    onClick={async()=>{ await addAnother()}}
                    disabled={!allValid}
                >
                    {addAnotherLabel}
                </RepeatStyledButton>
            );
        }
    }

    if (RTL){
        header = makeRTL(header);
        radioGroup = makeRTL(radioGroup);
    }

    console.log('----question----', question)
    console.log('---rootAnswer---', rootAnswer)

    const shouldShowTable = isRepeating && Array.isArray(rootAnswer) && rootAnswer.length > 0;

    return <div className={classes.mainContainer}>
        {header}
        {shouldShowTable && renderPreviewTable()}
        <div className={classes.layout}>
            {isRepeating && <div className={classes.repeatLeftSide}>
                {repeatButtons}
            </div>}
            <div className={classes.contentRightSide}>
                {partyQuestion && radioGroup}
                {partyQuestion && partyValue && children.map(q => !q.read_only && q.conditions &&
                    q.conditions[0].question_id === partyQuestion.id && q.conditions[0].value === partyValue.toString() && <WizardQuestionView
                        key={q.id} question={q}
                        onAnswerChange={onChildAnswerChange}
                        answer={childAnswers[q.id] || { question_id: q.id, value: questionnaire.defaults[q.id] }}
                        parentAnswer={rootAnswer}
                        contactsValue={contactsValue[q.contact_field] || ''}
                        childAnswers = {!!childAnswers}
                        partyQuestion = {partyQuestion}
                    />
                )}
                {!partyQuestion && children.map(q => <WizardQuestionView
                        key={q.id} question={q}
                        onAnswerChange={onChildAnswerChange}
                        answer={childAnswers[q.id] || { question_id: q.id, value: questionnaire.defaults[q.id] }}
                        parentAnswer={rootAnswer}
                        contactsValue={contactsValue[q.contact_field] || ''}
                        childAnswers = {!!childAnswers}
                    />
                )}
            </div>
        </div>
    </div>;
}